import * as React from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import {
  MdOutlineDashboard,
  MdOutlineNightlight,
  MdOutlinePeopleAlt,
  MdOutlineWbSunny,
  MdOutlineNotificationAdd,
} from "react-icons/md";
import { RxHamburgerMenu } from "react-icons/rx";
import { useNavigate } from "react-router";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Switch,
} from "@mui/material";
import { AsideMenuItem, AsideMenuItemProps } from "./AsideMenuItem";
import { FaSolarPanel, FaMapMarkerAlt } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import AsideMenuHeader from "./AsideMenuHeader";
import { loginApi, usersApi } from "../../services/api";
import { darkTheme, darkThemeTwo, lightTheme, lightThemeTwo } from "../themes/themes";
import SelectUsinaDashboardMenu from "../../modules/dashboard/components/SelectUsinaDashboardMenu";
import { CardsAdder } from "./CardsAdder";
import { DashboardContext } from "../../modules/dashboard/context/DashboardContexProvider";
import ReplayIcon from "@mui/icons-material/Replay";
import { getDefaultCardsConfig, getDefaultLayouts } from "../themes/defaultLayout";
import {
  defaultCardsDisplayableProps,
  defaultCardsDisplayableColorProps,
} from "../themes/defaultLayoutData";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
// import ListIcon from "@mui/icons-material/List";
import { RopMenuAccordion } from "./RopMenuAccordion";
import GroupsIcon from "@mui/icons-material/Groups";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import { RopMenuDashboardAccordion } from "./RopMenuDashboardAccordion";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import BadgeIcon from "@mui/icons-material/Badge";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import SelectClientDashboardMenu from "../../modules/dashboard/components/SelectedClientDashboardMenu";
import SummarizeIcon from "@mui/icons-material/Summarize";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { CiCircleQuestion } from "react-icons/ci";
import FilterCardModal, {
  CardFilterOptionsEnum,
} from "../../modules/dashboard/components/modal/FilterCardModal";
import { useState } from "react";
import { sendAllDashboardHistoryParams } from "./AsideMenu";
import { useRopV2AppNative } from "../../modules/ropv2app/context/RopV2AppNativeContext";
import CheckBoxTableRow from "../../modules/users/components/CheckBoxTableRow";
import CachedIcon from '@mui/icons-material/Cached';
import { ConfirmationModal } from "./ConfirmationModal";
import BarChartIcon from '@mui/icons-material/BarChart';
import SelectClusterMenu from "../../modules/dashboard/components/SelectedClusterMenu";
import SelectClientFilterMenu from "./SelectClientFilterMenu";
import SelectUsinaFilterMenu from "./SelectUsinaFilterMenu";
import WaterfallChartIcon from '@mui/icons-material/WaterfallChart';


type MobileMenuItemProps = {
  title: string;
  icon: React.ReactNode;
  route: string;
  URI?: string;
};

export default function MobileMenu() {
  const {
    bottomMenuHeight,
    theme,
    setUser,
    setTheme,
    bodyHeight,
    selectedDashboardUsina: selectedUsina,
    selectedDashboardClient: selectedClient,
    layout,
    setLayout,
    userClients,
    clientMenuResources,
    user,
    toastNotifications,
    setToastNotifications
  } = React.useContext(MainContext);
  const {
    setLayoutsConfig,
    layoutsConfig,
    setCardsConfig,
    setCardsDisplayableProps,
    setCardsDisplayableColorProps,
    canEditLayout,
    setCanEditLayout,
    cardsConfig,
    setRequestParamCards,
    selectedUsinaHasTrackers,
  } = React.useContext(DashboardContext);
  const [value, setValue] = React.useState<number>();
  const [showMenu, setShowMenu] = React.useState(false);
  const navigate = useNavigate();

  const { pushDeviceId } = useRopV2AppNative();

  const path = window.location.pathname;
  const isDashboard = window.location.pathname.includes("/dashboard");
  const isDashboardEdit = window.location.pathname.includes("/dashboard/edit");

  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [dateFilter, setDateFilter] = useState<CardFilterOptionsEnum>(
    CardFilterOptionsEnum.Live
  );
  const [date, setDate] = useState<Date | null>(new Date());

  const [openConfirmationLayoutModal, setOpenConfirmationLayoutModal] = useState(false);

  const handleConfirmSave = async () => {
    try {
      await usersApi.resetUsersLayouts()

      if (user) {
        const response = await usersApi.getUser(user?.userId)

        let updatedUser = user;

        if (response.resetLayout) {
          setCardsConfig(getDefaultCardsConfig(selectedUsinaHasTrackers ?? false));
          setLayoutsConfig(getDefaultLayouts(selectedUsinaHasTrackers ?? false));
          setCardsDisplayableProps(defaultCardsDisplayableProps);

          try {
            await usersApi.resetLayoutToFalse(user.userId);
            updatedUser.resetLayout = false
          }
          catch (_err) {
            updatedUser.resetLayout = response.resetLayout ?? false
          }
        }

        setUser(updatedUser)
      }

      const newNotifications = {
        isAdding: true,
        notifications: [
          ...toastNotifications.notifications,
          {
            severity: "success" as const,
            text: `Layouts de usuários resetados com sucesso`,
          },
        ],
      };
      setToastNotifications(newNotifications);
    } catch (_err) {
      const newNotifications = {
        isAdding: true,
        notifications: [
          ...toastNotifications.notifications,
          {
            severity: "error" as const,
            text: `Houve um erro ao resetar os layouts dos usuários, tente novamente!`,
          },
        ],
      };
      setToastNotifications(newNotifications);
    }
  }

  const onConfirmFilterModal = () => {
    sendAllDashboardHistoryParams(
      selectedUsina,
      date,
      dateFilter,
      cardsConfig,
      setRequestParamCards
    );
    setOpenFilterModal(false);
  };

  const bottomNavigationItems: MobileMenuItemProps[] = [
    {
      icon: <MdOutlineDashboard />,
      title: "Dashboard",
      route: "/dashboard",
      URI: "/Dashboard"
    },
    {
      icon: <GroupsIcon />,
      title: "Clientes",
      route: "/clients",
      URI: "/Clients"
    },
    {
      icon: <RxHamburgerMenu />,
      title: "Menu",
      route: "",
      URI: "/Menu"
    },
  ];

  const items = bottomNavigationItems.filter((item) => clientMenuResources.some(resource => resource.uri || "/Menu" === item.URI));

  const backgroundImage = theme.backgroundImage;

  React.useEffect(() => {
    if (showMenu) return;
    updateValue();
  }, [path]);
  React.useEffect(() => {
    if (showMenu) {
      setValue(2);
    } else {
      updateValue();
    }
  }, [showMenu]);

  const updateValue = () => {
    if (value == 2) {
      setValue(undefined);
      return;
    }
    const index = items.findIndex((item) => {
      return path.includes(item.route);
    });

    setValue(index);
  };
  async function logout() {
    await loginApi.logout({
      pushDeviceId: pushDeviceId || undefined,
    });
    setUser(undefined);
    navigate("/login");
  }
  const onItemClick = (route: string) => {
    navigate(route);
    setShowMenu(!showMenu);
  };
  const expandedItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <AssessmentIcon style={style} />,
      title: "Boletim Diário",
      onClick: () => {
        onItemClick("/usinas/boletim-diario");
      },
      route: "/usinas/boletim-diario",
      cantShow: false,
      URI: "/Relatorios/diario-info"
    },
    {
      icon: (style) => <SummarizeIcon style={style} />,
      title: "Boletim Mensal",
      onClick: () => {
        onItemClick("/usinas/boletim-mensal");
      },
      route: "/usinas/boletim-mensal",
      cantShow: false,
      URI: "/Relatorios/diario-mensal"
    },
    {
      icon: (style) => <SummarizeIcon style={style} />,
      title: "Boletim Personalizado",
      onClick: () => {
        onItemClick("/usinas/boletim-personalizado");
      },
      route: "/usinas/boletim-personalizado",
      cantShow: false,
      URI: "/Relatorios/personalizado"
    },
    {
      icon: (style) => <NotificationImportantIcon style={style} />,
      title: "Alarmes",
      onClick: () => {
        onItemClick("/alarm/equipment-alarms-list");
      },
      route: "/alarm/equipment-alarms-list",
      cantShow: false,
      URI: "/Alarms/current/{usinaId}"
    },
    //TODO: o acesso ao menu de centro de operações foi hardcoded temporariamente para apresentação do novo módulo, devemos atualizar os bancos de acordo com os perfis que devem acessar, e remover a escrita hardcoded
    {
      icon: (style) => <WaterfallChartIcon style={style} />,
      title: "Centro de Operações Solar",
      route: "/operations/center",
      URI: "/operations/center"
    },
    {
      icon: (style) => <AssignmentIcon style={style} />,
      title: "Solicitações de serviço",
      onClick: () => {
        onItemClick("/service-request/list");
      },
      route: "/service-request/list",
      cantShow: false,
      URI: "/Sismetro"
    },
    {
      icon: (style) => <SolarPowerIcon style={style} />,
      title: "Detalhes da Usina",
      route: `usinas/details/${selectedUsina?.usinaIds.id}`,
      onClick: () => {
        onItemClick(`usinas/${selectedUsina?.usinaIds.id}`);
      },
      URI: "/Usina/{usinaId}"
    },
    {
      icon: (style) => <CiCircleQuestion style={style} />,
      title: "Dúvidas Frequentes - FAQ",
      route: `/faq`,
      onClick: () => {
        onItemClick(`/faq`);
      },
      cantShow: false,
    },
  ];

  const boletimItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <AssessmentIcon style={style} />,
      title: "Boletim Diário",
      onClick: () => {
        onItemClick("/usinas/boletim-diario");
      },
      route: "/usinas/boletim-diario",
      cantShow: false,
      URI: "/Relatorios/diario-info"
    },
    {
      icon: (style) => <SummarizeIcon style={style} />,
      title: "Boletim Mensal",
      onClick: () => {
        onItemClick("/usinas/boletim-mensal");
      },
      route: "/usinas/boletim-mensal",
      cantShow: false,
      URI: "/Relatorios/diario-mensal"
    },
    {
      icon: (style) => <SummarizeIcon style={style} />,
      title: "Boletim Personalizado",
      onClick: () => {
        onItemClick("/usinas/boletim-personalizado");
      },
      route: "/usinas/boletim-personalizado",
      cantShow: false,
      URI: "/Relatorios/personalizado"
    },
    {
      icon: (style) => <SummarizeIcon style={style} />,
      title: "Boletim Parcial",
      onClick: () => {
        onItemClick("/usinas/boletim-parcial");
      },
      route: "/usinas/boletim-parcial",
      cantShow: false,
      URI: "/Relatorios/parcial"
    }
  ]

  const adminItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <FaSolarPanel style={style} />,
      title: "Usinas",
      onClick: () => {
        onItemClick("/usinas");
      },
      route: "/usinas",
      cantShow: false,
      URI: "/Usina"
    },
    {
      icon: (style) => <MdOutlinePeopleAlt style={style} />,
      title: "Usuários",
      onClick: () => {
        onItemClick("/users");
      },
      route: "/users",
      URI: "/User"
    },
    {
      icon: (style) => <MdOutlineNotificationAdd style={style} />,
      title: "Matriz de Alarmes",
      onClick: () => {
        onItemClick("/alarm/matriz");
      },
      route: "/alarm/matriz",
      URI: "/Alarms/all-alarms"
    },
    {
      icon: (style) => <MdOutlineNotificationAdd style={style} />,
      title: "Relatórios",
      onClick: () => {
        onItemClick("/usinas/relatorios");
      },
      route: "/usinas/relatorios",
      URI: "/relatorios"
    },
    {
      icon: (style) => <ManageSearchIcon style={style} />,
      title: "Análise de Consultas",
      onClick: () => {
        onItemClick("/sql-queries");
      },
      route: "/sql-queries",
      URI: "/sql-queries"
    },
  ];

  const bottomItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <MdOutlineNightlight style={style} />,
      title: "Tema Dark",
      onClick: () => {
        setTheme(layout == LayoutsConfig.LayoutOne ? darkTheme : darkThemeTwo);
      },
    },
    {
      icon: (style) => <MdOutlineWbSunny style={style} />,
      title: "Tema Light",
      onClick: () => {
        setTheme(layout == LayoutsConfig.LayoutOne ? lightTheme : lightThemeTwo);
      },
    },
    {
      icon: (style) => <FiLogOut style={style} />,
      title: "Sair",
      onClick: logout,
    },
  ];

  const myDataItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <ManageAccountsIcon style={style} />,
      title: "Perfil",
      cantShow: false,
      onClick: () => {
        onItemClick("/perfil");
      },
      URI: "/User/{id}"
    },
    {
      icon: (style) => <BadgeIcon style={style} />,
      onClick: () => {
        onItemClick(`clients/${selectedClient?.id}`);
      },
      route: `clients/${selectedClient?.id}`,
      title: "Detalhes do cliente",
      URI: "/Clients/{id}"
    },
  ];

  const dashboardItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <ReplayIcon style={style} />,
      title: "Layout Padrão",
      onClick: () => {
        setCardsConfig(getDefaultCardsConfig(selectedUsinaHasTrackers ?? false));
        setLayoutsConfig(getDefaultLayouts(selectedUsinaHasTrackers ?? false));
        setCardsDisplayableProps(defaultCardsDisplayableProps);
      },
      cantShow: isDashboardEdit,
      disabled: !canEditLayout,
    },
    {
      icon: (style) => <CachedIcon style={style} />,
      title: "Restaurar layout de usuários",
      onClick: () => {
        setOpenConfirmationLayoutModal(true)
      },
      cantShow: !userClients?.find(clients => clients.id == "656f0f50583fe04b0a62fc3d"),
      disabled: !canEditLayout,
    },
    {
      icon: (style) => <FormatPaintIcon style={style} />,
      title: "Cores Padrões",
      onClick: () => {
        setCardsDisplayableColorProps(defaultCardsDisplayableColorProps);
        location.reload();
      },
      cantShow: isDashboardEdit,
      disabled: !canEditLayout,
    },
    {
      icon: (style) => <RemoveCircleOutlineIcon style={style} />,
      title: "Limpar Layout",
      onClick: () => {
        setLayoutsConfig({
          ...layoutsConfig,
          layouts: {
            lg: [],
            md: [],
            sm: [],
            xs: [],
            xxs: [],
          },
        });
        setCardsConfig([]);
      },
      cantShow: isDashboardEdit,
      disabled: !canEditLayout,
    },
  ];

  const displayableDashboardItems = dashboardItems.filter(
    (item) => !item.cantShow
  );
  const canShowItems = expandedItems.filter((item) => !item.cantShow);
  const displayableItems = canShowItems.filter((item) => clientMenuResources.some(resource => resource.uri === item.URI));

  const canShowAdminItems = adminItems.filter((item) => !item.cantShow);
  const displayableAdminItems = canShowAdminItems.filter((item) => clientMenuResources.some(resource => resource.uri === item.URI));

  const canShowMyDataItems = myDataItems.filter((item) => !item.cantShow);
  const displayableMyDataItems = canShowMyDataItems.filter((item) => clientMenuResources.some(resource => resource.uri === item.URI));

  const canShowBoletimItems = boletimItems.filter((item) => !item.cantShow);
  const displayableBoletimItems = canShowBoletimItems.filter((item) => clientMenuResources.some(resource => resource.uri === item.URI));

  return (
    <>
      <Paper
        sx={{
          display: "block",
          height: bodyHeight,
          maxHeight: bodyHeight,
          width: "100%",
          position: "fixed",
          backgroundImage: backgroundImage,
          overflowY: "auto",
          left: showMenu ? 0 : "100%",
          transition: "left 0.3s ease-in-out",
          right: 0,
          zIndex: 1000,
        }}
      >
        <List>
          <AsideMenuHeader
            isShrunken={false}
            setIsShrunken={() => { }}
            cantShowShrinkButton={true}
            onClickTuneIcon={() => {
              setOpenFilterModal(true);
              setShowMenu(!showMenu);
            }}
            isDashboard={isDashboard}
          />
          {clientMenuResources.some(resource => resource.uri === "/Portfolio") && (
            <AsideMenuItem
              icon={(style) => <FaMapMarkerAlt style={style} />}
              title="Portfólio"
              route="/portfolio"
              onClick={() => {
                onItemClick("/portfolio");
              }}
              isShrunken={false}
              isMobile
            />)}
          <ListItem
            sx={{
              marginTop: "8px",
              marginBottom: "8px",
              width: "100%",
              display: "flex",
              rowGap: "8px",
              flexDirection: "column",
              justifyContent: "center",
            }}
            disablePadding
          >
            {path.includes("dashboard") ?
              <>
                <SelectClientDashboardMenu />
                <SelectUsinaDashboardMenu />
              </>
              :
              <>
                {path.includes("operations/control") || path.includes("portfolio") &&
                  <>
                    <SelectClientFilterMenu />
                    <SelectClusterMenu />
                    {path.includes("operations/center") &&
                      <SelectUsinaFilterMenu />
                    }
                  </>
                }
              </>
            }
          </ListItem>
          {clientMenuResources.some(resource => resource.uri === "/Dashboard") && clientMenuResources.some(resource => resource.uri === "/edicao-layout") && isDashboard && (
            <RopMenuDashboardAccordion
              isExpanded={isDashboard}
              setIsExpanded={() => { }}
              theme={theme}
              title={"Itens do Dashboard"}
              children={
                isDashboard && (
                  <>
                    {!isDashboardEdit && (
                      <>
                        <ListItem disablePadding>
                          <ListItemButton
                            sx={{
                              borderRadius: "10px",
                              height: "45px",
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "row",
                            }}
                          >
                            <ListItemIcon>
                              <Switch
                                checked={canEditLayout}
                                onChange={(_, checked) => {
                                  setCanEditLayout(checked);
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              sx={{
                                flex: "none",
                                WebkitFlex: "none",
                                width: "45px",
                              }}
                              primary="Edição"
                            />
                          </ListItemButton>
                        </ListItem>
                        {canEditLayout && (
                          <CardsAdder
                            isAccordionitem
                            disabled={!canEditLayout}
                            theme={theme}
                          />
                        )}
                      </>
                    )}
                    {displayableDashboardItems.map(
                      (item, index) =>
                        canEditLayout && (
                          <AsideMenuItem
                            icon={item.icon}
                            title={item.title}
                            key={index}
                            onClick={item.onClick}
                            route={item.route}
                            disabled={item.disabled}
                            isShrunken={false}
                            isAccordionitem
                          />
                        )
                    )}
                    <Divider
                      style={{
                        backgroundColor: theme.secondaryTextColor,
                      }}
                      variant="middle"
                    />
                  </>
                )
              }
            />
          )}
          {userClients?.find(clients => clients.id == "656f0f50583fe04b0a62fc3d") &&
            <ListItem disablePadding>
              <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <CheckBoxTableRow flexDirection="row" active={layout == LayoutsConfig.LayoutOne} onChange={() => { setLayout(LayoutsConfig.LayoutOne) }} name="Layout 1" />
                <CheckBoxTableRow flexDirection="row" active={layout == LayoutsConfig.LayoutTwo} onChange={() => { setLayout(LayoutsConfig.LayoutTwo) }} name="Layout 2" />
              </Box>
            </ListItem>}
          {displayableItems.map((item, index) => (
            <AsideMenuItem
              key={index}
              title={item.title}
              icon={item.icon}
              isShrunken={false}
              onClick={item.onClick}
              route={item.route}
              isMobile
            />
          ))}
          {boletimItems.length > 0 && (
            <RopMenuAccordion
              theme={theme}
              title="Boletim"
              icon={(style) => <BarChartIcon style={style} />}
            >
              {displayableBoletimItems.map((item, index) => (
                <AsideMenuItem
                  key={index}
                  title={item.title}
                  icon={item.icon}
                  isShrunken={false}
                  onClick={item.onClick}
                  route={item.route}
                  isMobile
                  isAccordionitem
                />
              ))}
            </RopMenuAccordion>)}
          {clientMenuResources.some(resource => resource.uri === "/Administrativo") && (
            <RopMenuAccordion
              theme={theme}
              title="Administrativo"
              icon={(style) => <EngineeringIcon style={style} />}
            >
              {displayableAdminItems.map((item, index) => (
                <AsideMenuItem
                  key={index}
                  title={item.title}
                  icon={item.icon}
                  isShrunken={false}
                  onClick={item.onClick}
                  route={item.route}
                  isMobile
                  isAccordionitem
                />
              ))}
            </RopMenuAccordion>)}
          {clientMenuResources.some(resource => resource.uri === "/Meus-dados") && (
            <RopMenuAccordion
              theme={theme}
              title="Meus dados"
              icon={(style) => <FolderSharedIcon style={style} />}
            >
              {displayableMyDataItems.map((item, index) => (
                <AsideMenuItem
                  key={index}
                  title={item.title}
                  icon={item.icon}
                  isShrunken={false}
                  onClick={item.onClick}
                  route={item.route}
                  isMobile
                  isAccordionitem
                />
              ))}
            </RopMenuAccordion>)}
          {bottomItems.map((item, index) => (
            <AsideMenuItem
              key={index}
              title={item.title}
              icon={item.icon}
              isShrunken={false}
              onClick={item.onClick}
              route={item.route}
              isMobile
            />
          ))}
        </List>
      </Paper>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_event, newValue: number) => {
          if (newValue == 2) {
            setShowMenu(!showMenu);
          } else {
            setShowMenu(false);
            navigate(items[newValue].route);
          }
          setValue(newValue);
        }}
        sx={{
          padding: "0.4rem",
          zIndex: 1000,
          background: "transparent ",
          boxShadow:
            "0px 1px 14px 0px rgba(0, 0, 0, 0.12), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)",
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: bottomMenuHeight,
        }}
      >
        {items.map((item, index) => (
          <BottomNavigationAction
            sx={{
              color: "#8F969E",
              "&.Mui-selected": {
                color: theme.primaryTextColor,
                borderRadius: "0.625rem",
              },
              marginRight: "0.5rem",
              marginLeft: "0.5rem",
            }}
            key={index}
            label={item.title}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
      <ConfirmationModal
        open={openConfirmationLayoutModal}
        setOpen={() => setOpenConfirmationLayoutModal(false)}
        title="Resetar Layout de usuários"
        contentText="Deseja confirmar a reinicialização do layout de todos os usuários?"
        onConfirm={handleConfirmSave}
      />
      <FilterCardModal
        onConfirm={onConfirmFilterModal}
        open={openFilterModal ?? false}
        setOpen={setOpenFilterModal ?? (() => { })}
        title={"Filtro do Dashboard"}
        possibleDateFilters={[
          {
            label: "Live",
            value: CardFilterOptionsEnum.Live,
          },
          {
            label: "Dia",
            value: CardFilterOptionsEnum.Dia,
          },
          // OBS: Em desenvolvimento
          // {
          //   label: "Mes",
          //   value: CardFilterOptionsEnum.Mes,
          // },
          // {
          //   label: "Ano",
          //   value: CardFilterOptionsEnum.Ano,
          // },
        ]}
        setDateFilterType={setDateFilter ?? (() => { })}
        setDate={setDate ?? (() => { })}
        date={date ?? null}
        dateFilterType={dateFilter ?? null}
      />
    </>
  );
}
